import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseHeaderLinkRemoved.meta';

export const useTrackShowcaseHeaderLinkRemoved = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseHeaderLinkRemoved = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackShowcaseHeaderLinkRemoved };
};
